import React from 'react';
import { Box, Stack, Typography, Pagination as MuiPagination, Select, MenuItem } from '@mui/material';
import { TableView } from '../TableView';
import { HubProposal } from '../../../api/types';
import { createTableColumns } from './tableConfig';
import { ProposalTableProps } from '../../../types';

export const HubTable = ({
  tableData,
  loading,
  pagination,
  sorting,
  filtering,
  ...actions
}: ProposalTableProps<HubProposal>) => {
  const columns = createTableColumns({
    tableData,
    sorting,
    filtering,
    ...actions,
  });

  return (
    <Stack spacing={2} height="100%" display="flex" flexDirection="column">
      <Box flex={1} overflow="auto">
        <TableView<HubProposal>
          loading={loading}
          columns={columns}
          height="100%"
          tableData={tableData}
          noData="No data about proposals"
          loadingText="Proposals loading..."
          withPagination={false} // Disable client-side pagination
          sorting={sorting}
        />
      </Box>

      {pagination && (
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          padding="1rem"
          borderTop="1px solid #e0e0e0"
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="body2">Rows per page:</Typography>
            <Select
              size="small"
              value={pagination.perPage}
              onChange={e => pagination.onPageSizeChange(Number(e.target.value))}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </Stack>

          <Stack direction="row" spacing={2} alignItems="center">
            <Typography variant="body2">
              {`Showing ${(pagination.page - 1) * pagination.perPage + 1}-${Math.min(
                pagination.page * pagination.perPage,
                pagination.total
              )} of ${pagination.total}`}
            </Typography>

            <MuiPagination
              page={pagination.page}
              count={pagination.totalPages}
              onChange={(_, page) => pagination.onPageChange(page)}
              showFirstButton
              showLastButton
              color="primary"
            />
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};
